import { render } from "./LoginWithGooglePage.vue?vue&type=template&id=d2d51f22&scoped=true"
import script from "./LoginWithGooglePage.vue?vue&type=script&lang=js"
export * from "./LoginWithGooglePage.vue?vue&type=script&lang=js"

import "./LoginWithGooglePage.vue?vue&type=style&index=0&id=d2d51f22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d51f22"]])

export default __exports__